import React, { FC, useState } from "react";
import { ReactComponent as Hamburger } from "../assets/svg/hamburger.svg";
import { ReactComponent as ProfileCircle } from "../assets/svg/profile.svg";
import { useAppSelector } from "../store/hooks";
import { selectEVMAccount, selectSolAccount } from "../store/user/userSlice";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { SolWalletButton } from "./solana/SolWalletButton";
import ConnectModal from "./ConnectModal";

const buttonStyles =
  "p-1 text-white hover:bg-white hover:text-black mr-5 rounded-md font3-bold";

  const connectButtonStyles = "p-1 text-white bg-blue-500 hover:bg-blue-400 mr-5 rounded-md font3-bold pr-2 pl-2"

const TopNav: FC = () => {
  const evmAddress = useAppSelector(selectEVMAccount);
  const solAddress = useAppSelector(selectSolAccount);
  const [showModal, setShowModal] = useState<boolean>(false);

  const concatAddr = (addr: string) => {
    const strArr = addr.split("");
    const first = strArr.splice(0, 4);
    const last = strArr.splice(strArr.length - 5, 4);
    const returnedStr = first.join("") + "..." + last.join("");
    return returnedStr;
  };

  const handleConnectClick = () => {
    setShowModal(!showModal);
  };

  const handleBurgerClick = () => {
    const drawer = document.getElementById("drawer");
    if (drawer) {
      if (drawer.classList.contains("drawerOut")) {
        drawer.classList.remove("drawerOut");
        drawer.classList.add("drawerIn");
        setTimeout(() => {
          drawer.classList.add("hidden");
        }, 250);
      } else {
        drawer.classList.remove("hidden");
        drawer.classList.remove("drawerIn");
        drawer.classList.add("drawerOut");
      }
    }
  };

  return (
    <div className="flex flex-row w-full items-center h-[8vh] bg-black shadow-lg relative pl-12 pr-16">
      <div className="flex grow">
        <img src="../img/dfcntrl-logo-white.svg" height="175px" width="175px" />
      </div>
      <div className="flex flex-row">
        <div className="xs:hidden lg:flex">
          {/* <button className={buttonStyles}>Portfolio</button>
          <button className={buttonStyles}>Performance</button> */}
          <button onClick={handleConnectClick} className={connectButtonStyles}>
            Connect Wallet
          </button>
          {/* {evmAddress !== "" ? (
            <p className="text-white mr-3">EVM: {concatAddr(evmAddress)}</p>
          ) : (
            ""
          )}
          {solAddress !== "" ? (
            <p className="text-white mr-3">SOL: {concatAddr(solAddress)}</p>
          ) : (
            ""
          )} */}
        </div>

        <ConnectModal onClose={() => setShowModal(false)} show={showModal} />
        {/* <ProfileCircle className="fill-white hover:fill-blue-500 mr-3" /> */}
        <div id="hamburger" onClick={handleBurgerClick}>
          <Hamburger className="flex lg:show-on-mobile" cursor="pointer" />
        </div>
      </div>
    </div>
  );
};

export default TopNav;
